// extracted by mini-css-extract-plugin
module.exports = {"billImage":"BillGraphic_billImage__N3asL","rotate":"BillGraphic_rotate__eTSVn","toTheSide":"BillGraphic_toTheSide__o_4JG","waiting":"BillGraphic_waiting__qU1u2"};